'use strict';

module.exports = function (ngModule) {
    ngModule.filter('orderObjectBy', require('./orderobjectby'));
}


/** WEBPACK FOOTER **
 ** ./src/pages/filters/orderobjectby/index.js
 **/